export default "__VITE_ASSET__Bq$mve48__"